const anchor_links = document.querySelectorAll('a[href="#wh-single-article"]');

anchor_links.forEach(function (element) {

    element.addEventListener("click", (e) => {
		e.preventDefault();
		let hash = element.getAttribute("href");
		let target = document.querySelector(hash);
		let headerOffset = 100;
		let elementPosition = target.offsetTop;
		let offsetPosition = elementPosition - headerOffset;

		window.scrollTo({
		    top: offsetPosition,
		    behavior: "smooth"
		});
    })

})
